<!--
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 15:05:32
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-15 16:31:53
-->
<template>
  <div class="page-list">
    <!-- 实时存塘量 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>养殖场&nbsp;:</label>
          <el-select v-model="param.params.baseId" filterable @change="getGroupList(param.params.baseId)"
            placeholder="请选择养殖场">
            <el-option label="全部养殖场" value=""></el-option>
            <el-option v-for="item in baseList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>区域&nbsp;:</label>
          <el-select v-model="param.params.groupId" filterable placeholder="请选择区域">
            <el-option label="全部区域" value=""></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.groupName" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>批次&nbsp;:</label>
          <el-select v-model="seedlingDataId" multiple collapse-tags placeholder="请选择批次" @change="selectBatch"
            @remove-tag="removeTag">
            <el-option el-option label="全选" value="全选" @click.native="selectAll"></el-option>
            <el-option :key="item.seedlingDataId" v-for="item in PiCiList" :label="item.seedlingDataName"
              :value="item.seedlingDataId">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品类&nbsp;:</label>
          <el-select v-model="param.params.breedTypeId" filterable placeholder="请选择品类">
            <el-option label="全部品类" value=""></el-option>
            <el-option :key="item.id" v-for="item in PinLeiList" :label="item.breedTypeName"
              :value="item.breedTypeId"></el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="param.params.breedId" filterable placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option :key="item.id" v-for="item in PinZhongList" :label="item.breedName"
              :value="item.breedId"></el-option>
          </el-select>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="pageSearch">查询</div>
        <div class="reset-btn" @click="reSet">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="page-list-content">
      <div class="page-list-title">
        <div><i class="title-icon"></i>育苗单位利润计划与实际比</div>
        <div>单位 : {{ tableTitle }}</div>
        <div></div>
        <div style="cursor: unset">
          <el-dropdown style="margin-right: 20px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="CompanyDetailedPage" style="cursor: pointer; color: #1800f9; margin-right: 20px">明细</span>
          <span @click="doExport" style="cursor: pointer"><i
              class="title-export-btn iconfont icon-a-List-Export"></i>导出报表</span>
        </div>
      </div>
      <el-table :row-class-name="tableRowClassName" :data="tableData" :max-height="tableHeight" border style="width: 100%"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"></el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="groupName" label="区域"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="seedlingDataName" label="育苗批次">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="养殖品类"></el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="breedName" label="养殖品种"></el-table-column>
        <el-table-column label="单位售价(元/尾)">
          <el-table-column prop="unitPriceTarget" label="计划"></el-table-column>
          <el-table-column prop="realityUnitPrice" label="实际"></el-table-column>
        </el-table-column>
        <el-table-column label="单位养殖成本(元/尾)">
          <el-table-column prop="unitCostTarget" label="计划"></el-table-column>
          <el-table-column prop="realityUnitCost" label="实际"></el-table-column></el-table-column>
        <el-table-column label="单位养殖利润（元/尾）">
          <el-table-column prop="unitProfitTarget" label="计划"></el-table-column>
          <el-table-column prop="realityUnitProfit" label="实际"></el-table-column></el-table-column>
        <el-table-column prop="harvestBoxNum" label="收获塘\箱总数"></el-table-column>
        <el-table-column prop="harvestNumber" label="收获总产量(尾)"></el-table-column>
        <el-table-column prop="survivalPercentage" label="平均成活率%"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  initPageList,
  getAllJiGou,
  getAllPiCi,
  getAllPinLei,
  getAllPinZhong,
} from "./ym-profit-services";
import {
  queryBaseDataListByRole,
  queryBaseGroupList,
} from "@/api/middle/common";
import Page from "@/utils/methods/page";
export default {
  name: "yc",
  data() {
    return {
      tableTitle: "",
      tableDate: "",
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "seedlingDataName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      param: {
        currPage: 1, //第几页
        pageSize: 10, //每页条数
        // orderBy: "desc",//排序
        // orderByName: "org_name",//排序字段
        params: {
          orgId: localStorage.getItem("orgId"), //机构id（公司）
          baseId: "",
          groupId: "", //养殖造次id
          breedTypeId: "", //养殖场Id
          seedlingDataId: [], //育苗批次id
          breedId: "", //养殖品种id
          year: null, //年
          startDate: null, //开始时间 月
          type: "Y", //时间查询类型 Y年 M月
          breedTypeClass: "egg", //分页查询类型 egg育苗 fish养成
        },
      },
      date: null, //月份区间双向绑定数据
      dateSelectNum: 1,
      PageDisplay: true,
      value: "",
      tableData: [],
      baseList: [], // 养殖场列表
      groupList: [], // 分组列表
      GongSiList: [], //养殖场下拉数据
      PiCiList: [], //批次下拉数据
      PinLeiList: [], //品类下拉数据
      PinZhongList: [], //品种下拉数据
      seedlingDataId: [],
    };
  },
  computed: {},
  methods: {
    // 根据养殖场获取区域
    getGroupList(baseId) {
      this.param.params.groupId = "";
      this.groupList = [];
      if (!baseId) return
      this.param.params.groupId = "";
      queryBaseGroupList({
        baseId,
      }).then((res) => {
        if (res.code == "0000") {
          this.groupList = res.data;
        }
      });
    },
    // 跳转到单位利润计划与实际比明细报表
    CompanyDetailedPage() {
      let routeUrl = this.$router.resolve({
        path: "/month/ym/profit/detailed",
        // query: { id: 96 },
      });
      window.open(routeUrl.href, "_blank");
    },
    reSet() {
      this.groupList = []
      this.param = {
        currPage: 1, //第几页
        pageSize: 10, //每页条数
        // orderBy: "desc",//排序
        // orderByName: "org_name",//排序字段
        params: {
          orgId: localStorage.getItem("orgId"), //机构id（公司）
          baseId: "",
          groupId: "", //养殖造次id
          breedTypeId: "", //养殖场Id
          seedlingDataId: [], //育苗批次id
          breedId: "", //养殖品种id
          year: null, //年
          startDate: null, //开始时间 月
          type: "Y", //时间查询类型 Y年 M月
          breedTypeClass: "egg", //分页查询类型 egg育苗 fish养成
        },
      };
      this.seedlingDataId = [];
      this.initPage(this.param);
    },
    doExport() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(async () => {
          const param = {
            orgId: this.param.params.orgId,
            groupId: this.param.params.groupId,
            breedTypeId: this.param.params.breedTypeId,
            seedlingDataId: this.param.params.seedlingDataId,
            breedId: this.param.params.breedId,
            year: this.param.params.year,
            startDate: this.param.params.startDate,
            type: this.param.params.type,
            breedTypeClass: "egg",
            fileName: "育苗-单位利润计划与实际比",
          };
          const flag = await Page.exportDatas(
            "/outFishProfitGroup/exportOutFishProfitGroupList",
            param
          );
        })
        .catch(() => { });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.groupName === "合计") {
        return "heji-row";
      }
    },
    // 获取所有下拉选择项
    getAllSearchSelect() {
      let param = {
        breedTypeClass: "egg",
        orgId: localStorage.getItem("orgId"),
      };
      Promise.all([
        getAllJiGou(param),
        getAllPiCi(param),
        getAllPinLei(param),
        getAllPinZhong(param),
      ])
        .then((result) => {
          const [JiGouData, PiCiData, PinLeiData, PinZhongData] = result;
          this.GongSiList = JiGouData.data;
          this.PiCiList = PiCiData.data;
          this.PinLeiList = PinLeiData.data;
          this.PinZhongList = PinZhongData.data;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    selectAll() {
      if (this.seedlingDataId.length < this.PiCiList.length) {
        this.seedlingDataId = [];
        this.PiCiList.map((item) => {
          this.seedlingDataId.push(item.seedlingDataId);
        });
        this.seedlingDataId.unshift("全选");
      } else {
        // 取消全选
        this.seedlingDataId = [];
      }
      if (this.seedlingDataId.length > 0) {
        if (this.seedlingDataId[0] == "全选") {
          this.param.params.seedlingDataId = ["total"];
        } else {
          this.param.params.seedlingDataId = this.seedlingDataId;
        }
      }
    },
    removeTag(val) {
      if (val === "全选") {
        this.seedlingDataId = [];
        this.param.params.seedlingDataId = [];
      }
    },
    selectBatch(val) {
      if (!val.includes("全选") && val.length === this.PiCiList.length) {
        this.seedlingDataId.unshift("全选");
      } else if (
        val.includes("全选") &&
        val.length - 1 < this.PiCiList.length
      ) {
        this.seedlingDataId = this.seedlingDataId.filter((item) => {
          return item !== "全选";
        });
      }
      if (this.seedlingDataId.length > 0) {
        if (this.seedlingDataId[0] == "全选") {
          this.param.params.seedlingDataId = ["total"];
        } else {
          this.param.params.seedlingDataId = this.seedlingDataId;
        }
      }
    },
    // 查询按钮
    pageSearch() {
      this.initPage(this.param);
    },
    PageSearchClose() {
      Page.PageSearchClose(this);
    },
    PageSearchOn() {
      Page.PageSearchOn(this);
    },
    initPage(data) {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      initPageList(data)
        .then((res) => {
          if (data.params.type === "Y") {
            this.tableDate = data.params.year;
          } else {
            this.tableDate = data.params.startDate;
          }
          this.tableData = res.data.list;
          setTimeout(() => {
            loading.close();
          }, 0);
        })
        .catch((err) => {
          setTimeout(() => {
            loading.close();
          }, 500);
        });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
  },
  mounted() {
    this.tableTitle = localStorage.getItem("orgName");
    this.getAllSearchSelect();
    Page.pagesTableFixed();
    // 养殖场
    queryBaseDataListByRole().then((res) => {
      if (res.code == "0000") {
        this.baseList = res.data;
      }
    });
    this.initPage(this.param);
  },
  // 数据监听
  watch: {
    "param.params.type": function (newVal, oldVal) {
      if (newVal === "Y") {
        this.param.params.startDate = null;
        this.param.params.year = Page.getCurrentYear();
        this.initPage(this.param);
        return;
      }
      this.param.params.year = null;
      const Timer = new Date();
      this.date = [Timer, Timer]; //给到当前年月-显示在日期区间选择框内
      this.param.params.startDate = Page.getCurrentMonth();
      this.initPage(this.param);
    },
  },
};
</script>

<style lang="less" scoped></style>